const UTILS = require("./utils.js");
const config = require("../config.js");
var v12228;
const vA663 = ["N", "E", "S", "W"];
const vLN68 = 6;
const vLN69 = 6;
const vLN316 = 3;
const vLN3003 = 300;
class C285 {
  constructor() {
    this.enabled = false;
    this.width = vLN3003;
    this.scale = 1;
    const v12229 = document.getElementById("miniMapOverlay");
    this.dom = v12229;
    const v12230 = document.getElementById("miniMapCanvas");
    this.canvas = v12230;
    this.setScale(1);
    this.ctx = v12230.getContext("2d", {
      alpha: false
    });
    this.type = 0;
    this.focusedPlayer = null;
    this.mapBounds = {
      min: [0, 0, 0],
      max: [0, 0, 0]
    };
    this.MAX_HEIGHT = 0;
    this.showObjects = true;
    this.playerBounds = {
      min: [0, 0, 0],
      max: [0, 0, 0]
    };
    this.rotateOnCenter = true;
    this.mapScale = vLN68;
    this.focusedScale = vLN316;
    this.hudScale = vLN69;
    this.centeredOnPlayer = true;
    this.mapImage = new Image();
    this.mapImage.onload = () => this.mapImage.isReady = true;
    this.useMapAnchors = false;
    this.useImage = false;
  }
  setScale(p15075) {
    const v12231 = vLN3003 * p15075;
    this.width = v12231;
    this.scale = p15075;
    this.canvas.width = v12231;
    this.canvas.height = v12231;
    this.dom.style.width = v12231 + "px";
    this.dom.style.height = v12231 + "px";
    document.documentElement.style.setProperty("--mm-scale", p15075);
  }
  setHudScale(p15076) {
    this.hudScale = vLN69 * p15076;
  }
  setZoom(p15077) {
    this.focusedScale = vLN316 * p15077;
    this.mapScale = vLN316 * p15077;
    if (this.mapBounds.unscaledMin || this.mapBounds.unscaledMax) {
      const v12232 = [...this.mapBounds.unscaledMin].map(p15078 => p15078 < 0 ? p15078 -= this.mapScale : p15078 += this.mapScale);
      const v12233 = [...this.mapBounds.unscaledMax].map(p15079 => p15079 < 0 ? p15079 -= this.mapScale : p15079 += this.mapScale);
      this.mapBounds.min = v12232;
      this.mapBounds.max = v12233;
      this.mapBounds.width = Math.abs(v12233[0] - v12232[0]);
      this.mapBounds.height = Math.abs(v12233[2] - v12232[2]);
    }
  }
  setBounds(p15080) {
    this.useMapAnchors = p15080.map.manager.mapAnchors.length > 0;
    let vA664 = [0, 0, 0];
    let vA665 = [0, 0, 0];
    let vA666 = [0, 0, 0];
    const vLN82 = 8;
    const v12234 = this.useMapAnchors ? p15080.map.manager.mapAnchors : p15080.map.spawns;
    for (let vLN02069 = 0; vLN02069 < v12234.length; ++vLN02069) {
      v12228 = v12234[vLN02069];
      if (v12228.x < vA664[0]) {
        vA664[0] = v12228.x;
      }
      if (v12228.x > vA665[0]) {
        vA665[0] = v12228.x;
      }
      if (v12228.z < vA664[2]) {
        vA664[2] = v12228.z;
      }
      if (v12228.z > vA665[2]) {
        vA665[2] = v12228.z;
      }
      if (v12228.y > vA665[1]) {
        vA665[1] = v12228.y;
      }
    }
    const v12235 = vA665[0] - vA664[0];
    const v12236 = vA665[2] - vA664[2];
    const v12237 = v12235 / vLN82;
    const v12238 = v12236 / vLN82;
    vA666[0] = vA664[0] + v12235 / 2;
    vA666[2] = vA664[2] + v12236 / 2;
    if (this.useMapAnchors) {
      const v12239 = Math.max(v12235, v12236);
      vA664[0] = vA666[0] - v12239 / 2;
      vA664[2] = vA666[2] - v12239 / 2;
      vA665[0] = vA666[0] + v12239 / 2;
      vA665[2] = vA666[2] + v12239 / 2;
    } else {
      vA665[0] += v12237 * 2;
      vA664[0] -= v12237 * 2;
      vA665[2] += v12238 * 2;
      vA664[2] -= v12238 * 2;
    }
    const v12240 = Math.abs(vA665[0] - vA664[0]);
    const vA667 = [...vA664];
    const vA668 = [...vA665];
    vA664 = vA664.map(p15081 => p15081 < 0 ? p15081 -= this.mapScale : p15081 += this.mapScale);
    vA665 = vA665.map(p15082 => p15082 < 0 ? p15082 -= this.mapScale : p15082 += this.mapScale);
    const v12241 = Math.abs(vA665[0] - vA664[0]);
    const v12242 = Math.abs(vA665[2] - vA664[2]);
    this.mapBounds = {
      min: vA664,
      max: vA665,
      width: v12241,
      height: v12242,
      cen: vA666,
      unscaledWidth: v12240,
      unscaledMin: vA667,
      unscaledMax: vA668
    };
    this.MAX_HEIGHT = p15080.map.manager.objects.filter(p15083 => !p15083.noMinimap).map(p15084 => p15084.y).reduce((p15085, p15086) => Math.max(p15085, p15086));
  }
  updatePlayerBounds(p15087) {
    const v12243 = this.focusedScale;
    const v12244 = this.mapBounds.width / v12243;
    const v12245 = this.mapBounds.height / v12243;
    this.playerBounds.min[0] = p15087.x - v12244;
    this.playerBounds.min[2] = p15087.z - v12245;
    this.playerBounds.max[0] = p15087.x + v12244;
    this.playerBounds.max[2] = p15087.z + v12245;
  }
  convertCord(p15088, p15089) {
    return p15088.map(this.centeredOnPlayer && this.type == 1 ? this.playerBounds.min[p15089] : this.mapBounds.min[p15089], this.centeredOnPlayer && this.type == 1 ? this.playerBounds.max[p15089] : this.mapBounds.max[p15089], -(this.width / 2), this.width / 2);
  }
  cropMinCord(p15090) {
    return Math.max(p15090, -(this.width / 2));
  }
  cropMaxCord(p15091) {
    return Math.min(p15091, this.width / 2);
  }
  getColor(p15092) {
    const v12246 = 35 - p15092 / this.MAX_HEIGHT * 20;
    return "hsl(220, 25%, " + v12246 + "%)";
  }
  drawDirectionalBlip(p15093, p15094, p15095, p15096, p15097, p15098, p15099) {
    p15093 = this.convertCord(p15093, 0);
    p15095 = this.convertCord(p15095, 2);
    const v12247 = p15098 == -1 && !this.type;
    const v12248 = v12247 ? 0.5 : 1;
    const v12249 = v12248 / 2;
    const v12250 = this.hudScale * this.scale;
    const v12251 = this.type && !p15099;
    this.ctx.save(1);
    this.ctx.translate(p15093, p15095);
    this.ctx.rotate(p15096 * -1);
    this.ctx.lineWidth = this.scale * 2;
    this.ctx.strokeStyle = v12247 || p15099 ? "rgba(150, 150, 150, " + v12248 + ")" : v12251 ? "rgba(158, 235, 86, " + v12248 + ")" : p15097 == 1 ? "rgba(1, 107, 237, " + v12248 + ")" : "rgba(236, 107, 1, " + v12248 + ")";
    this.ctx.fillStyle = v12247 || p15099 ? "rgba(150, 150, 150, " + v12249 + ")" : v12251 ? "rgba(158, 235, 86, " + v12249 + ")" : p15097 == 1 ? "rgba(1, 107, 237, " + v12249 + ")" : "rgba(236, 107, 1, " + v12249 + ")";
    this.ctx.beginPath();
    if (this.focusedPlayer && this.focusedPlayer.id == p15098) {
      this.ctx.strokeStyle = "rgba(255, 255, 255, " + v12248 + ")";
    }
    this.ctx.moveTo(0, v12250 * 0.5);
    this.ctx.lineTo(-v12250 * 1.1, v12250);
    this.ctx.lineTo(0, -v12250 * 1.25);
    this.ctx.lineTo(v12250 * 1.1, v12250);
    this.ctx.lineTo(0, v12250 * 0.5);
    this.ctx.fill();
    this.ctx.stroke();
    this.ctx.closePath();
    this.ctx.restore(-1);
  }
  drawBlip(p15100, p15101, p15102) {
    p15100 = this.convertCord(p15100, 0);
    p15101 = this.convertCord(p15101, 2);
    this.ctx.save(1);
    this.ctx.translate(p15100, p15101);
    const v12252 = p15102 / config.playerBlipTimer;
    this.ctx.globalAlpha = v12252;
    this.ctx.lineWidth = 1;
    this.ctx.fillStyle = "rgb(237, 66, 66)";
    this.ctx.strokeStyle = "rgb(0, 0, 0)";
    const v12253 = this.hudScale * this.scale;
    this.ctx.beginPath();
    this.ctx.arc(0, 0, v12253, 0, Math.PI * 2);
    this.ctx.fill();
    this.ctx.stroke();
    this.ctx.closePath();
    this.ctx.restore(-1);
  }
  drawObject(p15103, p15104, p15105) {
    p15104 = p15104 || "rgb(255, 255, 0)";
    const v12254 = this.convertCord(p15103.x, 0);
    const v12255 = this.convertCord(p15103.z, 2);
    const v12256 = this.convertCord(p15103.x - p15103.width, 0);
    const v12257 = this.convertCord(p15103.z - p15103.length, 2);
    const v12258 = this.convertCord(p15103.x + p15103.width, 0);
    const v12259 = this.convertCord(p15103.z + p15103.length, 2);
    const v12260 = v12258 - v12256;
    const v12261 = v12259 - v12257;
    this.ctx.save(1);
    this.ctx.translate(v12254, v12255);
    this.ctx.lineWidth = 3;
    this.ctx.strokeStyle = "rgba(0, 0, 0, 0.8)";
    this.ctx.strokeRect(-v12260 / 2, -v12261 / 2, v12260, v12261);
    this.ctx.lineWidth = 1.5;
    if (p15105) {
      this.ctx.fillStyle = p15104;
      this.ctx.fillRect(-v12260 / 2, -v12261 / 2, v12260, v12261);
    } else {
      this.ctx.strokeStyle = p15104;
      this.ctx.strokeRect(-v12260 / 2, -v12261 / 2, v12260, v12261);
    }
    this.ctx.restore(-1);
  }
  drawImage() {
    const v12262 = this.mapBounds.cen[0];
    const v12263 = this.mapBounds.cen[2];
    const v12264 = this.mapBounds.unscaledWidth / 2;
    const v12265 = this.mapBounds.unscaledWidth / 2;
    const v12266 = this.convertCord(v12262, 0);
    const v12267 = this.convertCord(v12263, 2);
    const v12268 = this.convertCord(v12262 - v12264, 0);
    const v12269 = this.convertCord(v12263 - v12265, 2);
    const v12270 = this.convertCord(v12262 + v12264, 0);
    const v12271 = this.convertCord(v12263 + v12265, 2);
    const v12272 = v12270 - v12268;
    const v12273 = v12271 - v12269;
    this.ctx.save(1);
    this.ctx.translate(v12266, v12267);
    this.ctx.drawImage(this.mapImage, -v12272 / 2, -v12273 / 2, v12272, v12273);
    this.ctx.restore(-1);
  }
  drawCardinalDirections() {
    const vLN83 = 8;
    this.ctx.save(1);
    this.ctx.beginPath();
    this.ctx.arc(0, 0, this.width / 2 - this.scale * 7, 0, Math.PI * 2);
    this.ctx.strokeStyle = "rgba(25, 25, 25, 0.85)";
    this.ctx.lineWidth = vLN83 * 2 * this.scale;
    this.ctx.stroke();
    this.ctx.restore(-1);
    this.ctx.font = vLN83 + "px GameFont";
    this.ctx.textBaseline = "middle";
    this.ctx.textAlign = "center";
    this.ctx.lineWidth = 1;
    this.ctx.fillStyle = "#FFF";
    let vLN02070 = 0;
    vA663.forEach(p15106 => {
      this.ctx.save(1);
      this.ctx.rotate(UTILS.toRad(vLN02070));
      this.ctx.translate(0, -(this.width / 2));
      this.ctx.fillText(p15106, 0, this.scale * 10);
      this.ctx.restore(-1);
      vLN02070 += 90;
    });
  }
  update(game, p15108, p15109, p15110, p15111) {
    const v12274 = this.type;
    this.type = p15111 ? 0 : 1;
    if (this.type != v12274) {
      this.dom.classList.toggle("roundMap", this.type == 1);
    }
    this.focusedPlayer = this.type ? null : p15108.spect.target;
    this.ctx.save(1);
    this.ctx.clearRect(0, 0, this.width, this.width);
    this.ctx.fillStyle = "rgb(59, 58, 57)";
    this.ctx.fillRect(0, 0, this.width, this.width);
    this.updatePlayerBounds(this.focusedPlayer || p15108.object.position);
    this.ctx.translate(this.width / 2, this.width / 2);
    const v12275 = this.rotateOnCenter && this.centeredOnPlayer && this.type == 1;
    if (v12275) {
      const v12276 = -(this.focusedPlayer ? this.focusedPlayer.xDire : p15108.xDr);
      this.ctx.rotate(v12276 * -1);
    }
    if (this.useImage && this.mapImage && this.mapImage.isReady) {
      this.drawImage();
    }
    if (!this.useImage && this.showObjects) {
      const v12277 = game.map.manager.objects.sort((p15112, p15113) => p15112.y - p15113.y);
      if (v12277.length > 0) {
        for (let vLN02071 = 0; vLN02071 < v12277.length; ++vLN02071) {
          if (v12277[vLN02071] && !v12277[vLN02071].noMinimap) {
            this.drawObject(v12277[vLN02071], this.getColor(v12277[vLN02071].y + v12277[vLN02071].height), true);
          }
        }
      }
    }
    if (game.mode && game.mode.objective && game.map.manager.objectives.length > 0 && game.map.manager.objectives[game.activeObjective]) {
      this.drawObject(game.map.manager.objectives[game.activeObjective]);
    }
    if (game.mode && (game.mode.flags || game.mode.oneflag) && game.map.manager.flags.length > 0) {
      for (let vLN02072 = 0; vLN02072 < game.map.manager.flags.length; ++vLN02072) {
        v12228 = game.map.manager.flags[vLN02072];
        if ((!game.mode.oneflag || v12228.neutral) && (game.mode.oneflag || !v12228.neutral)) {
          this.drawObject(v12228, v12228.team == p15109 ? "#2196F3" : "#ed4242");
        }
      }
    }
    if (game.mode && game.mode.site && game.map.manager.sites.length > 0) {
      for (let vLN02073 = 0; vLN02073 < game.map.manager.sites.length; ++vLN02073) {
        this.drawObject(game.map.manager.sites[vLN02073]);
      }
    }
    if (game.mode && game.mode.dom && game.map.manager.domzones.length > 0) {
      for (let vLN02074 = 0; vLN02074 < game.map.manager.domzones.length; ++vLN02074) {
        v12228 = game.map.manager.domzones[vLN02074];
        if (!v12228) {
          continue;
        }
        let v12278 = v12228.capturedBy == null ? "#dbdbdb" : v12228.capturedBy == p15109 ? "#5699EB" : "#eb5656";
        this.drawObject(v12228, v12278);
      }
    }
    for (let vLN02075 = 0; vLN02075 < game.players.list.length; ++vLN02075) {
      v12228 = game.players.list[vLN02075];
      if (v12228.minimapTimer) {
        v12228.minimapTimer -= p15110;
        if (v12228.minimapTimer <= 0) {
          v12228.minimapTimer = 0;
          v12228.minimapPos = null;
        }
      }
      let v12279 = p15109 == v12228.team || game.mode && game.mode.fakeNames && p15109 != 2;
      if (v12228.active && !v12228.isYou) {
        if (v12279 || p15111) {
          this.drawDirectionalBlip(v12228.x, v12228.y, v12228.z, v12228.xDire, v12228.team, v12228.id);
        } else if (v12228.minimapTimer) {
          this.drawBlip(v12279 ? v12228.x : v12228.minimapPos.x, v12279 ? v12228.z : v12228.minimapPos.z, v12228.minimapTimer);
        }
      }
    }
    if (!this.focusedPlayer && !this.type || !!this.type) {
      this.drawDirectionalBlip(p15108.object.position.x, p15108.object.position.y, p15108.object.position.z, p15108.xDr, 0, -1, !!this.type);
    }
    if (this.type == 1) {
      this.drawCardinalDirections();
    }
    this.ctx.restore(-1);
  }
  toggle(p15114, p15115) {
    const v12280 = p15114.mode.noMinimap || !p15114.config.minimaps;
    if (v12280) {
      p15115 = false;
    }
    if (p15114.customsData && config.isProd) {
      p15115 = false;
    }
    this.enabled = !!p15115;
    this.dom.style.display = p15115 ? "" : "none";
    timerHolder.classList.toggle("topLeftOld", !p15115);
    timerIcon.classList.toggle("topLeftOld", !p15115);
    timerVal.classList.toggle("topLeftOld", !p15115);
    timerInner.classList.toggle("topLeftOld", !p15115);
    matchInfo.classList.toggle("topLeftOld", !p15115);
    specNames.classList.toggle("topLeftOld", !p15115);
    specStats.classList.toggle("topLeftOld", !p15115);
    specSUS.classList.toggle("topLeftOld", !p15115);
  }
  updateImage(p15116) {
    let v12281 = p15116.map.maps[p15116.mapIndex];
    let v12282 = v12281.mmId && !/[^\dtlnesacdgxufq]+/gmi.test(v12281.mmId) ? v12281.mmId : "";
    if (v12282.length) {
      v12282 = parseInt((v12282 + "").replace(/[^\d]/gmi, ""));
      this.mapImage.isReady = false;
      this.mapImage.onload = () => this.mapImage.isReady = true;
      this.mapImage.src = UTILS.userAssetsUrl((v12282 || 0) + "/texture.png");
      this.useImage = true;
    } else {
      this.useImage = false;
    }
  }
  reset(p15117, p15118) {
    this.mapImage.isReady = false;
    this.setBounds(p15117);
    this.updateImage(p15117);
    this.toggle(p15117, p15118);
  }
}
module.exports = C285;